<template>
  <el-dialog class="pc-dialog pc-dialog__add-notebook-catalog"
    title="添加笔记"
    :visible.sync="visible"
    width="40rem"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="closeHandler"
    >
    <div class="path">上级：{{path.join(' / ')}} </div>
    <div class="name">
      <el-input :class="{'pc-is-error':invalid}" v-model="name" :placeholder="placeholder" size="small" @input="validateHandler"
        @keyup.native.enter="okHandler" ref="nameInput"/>
    </div>
    <span slot="footer" class="dialog-footer">
      <span class="pc-color-error" v-show="invalid">{{errorMessage}}</span>
      <el-button type="primary" size="small" @click="okHandler" :disabled="waiting">{{okButtonText}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { isNullOrWhiteSpace } from '@/common/utils'
import { operateError } from '@/common/errors'

export default {
  name: 'AddNotebookNoteDialog',
  data () {
    return {
      name: '',
      invalid: false,
      waiting: false
    }
  },
  computed: {
    ...mapGetters('dialog', {
      addNotebookNoteDailogValue: 'addNotebookNote'
    }),
    ...mapGetters('workbench/current', {
      notebook: 'notebook',
      catalogPaths: 'catalogPaths'
    }),
    visible: {
      get () {
        return this.addNotebookNoteDailogValue.visible
      },
      set (visible) {
        this.setAddNotebookNoteDailogValue({
          visible,
          data: {
            catalogId: ''
          }
        })
      }
    },
    placeholder () {
      return '请输入笔记名称'
    },
    okButtonText () {
      let text = '创建笔记'
      if (this.waiting) {
        text += ' ...'
      }
      return text
    },
    errorMessage () {
      return '笔记名称不能为空'
    },
    path () {
      return this.catalogPaths(this.addNotebookNoteDailogValue.data.catalogId)
    }
  },
  methods: {
    ...mapMutations('dialog', {
      setAddNotebookNoteDailogValue: 'SET_ADD_NOTEBOOK_NOTE'
    }),
    ...mapActions('workbench/current', {
      addNotebookNote: 'addNotebookNote'
    }),
    closeHandler () {
      this.name = ''
      this.invalid = false
      this.waiting = false
    },
    validateHandler () {
      if (isNullOrWhiteSpace(this.name)) {
        this.invalid = true
      } else {
        this.invalid = false
      }
    },
    async okHandler () {
      this.validateHandler()
      if (this.invalid) {
        return
      }
      try {
        this.waiting = true
        const result = await this.addNotebookNote({
          catalogId: this.addNotebookNoteDailogValue.data.catalogId,
          name: this.name
        })
        this.setAddNotebookNoteDailogValue({
          visible: false,
          data: {
            catalogId: ''
          }
        })
        this.$router.push({
          name: 'workbenchNotebookNote',
          params: {
            noteId: result.id
          }
        })
      } catch (e) {
        console.dir(e)
        operateError(e, '添加笔记')
      } finally {
        this.waiting = false
      }
    }
  },
  watch: {
    visible (newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.$refs.nameInput.focus()
        })
      }
    }
  }
}
</script>

<style lang="scss">
.pc-dialog__add-notebook-catalog {
}
</style>
